// Shared helpers for the Users tab sub-components (extracted from UsersTab.tsx).

export const inputCls = "w-full border border-secondary-300 rounded px-2 py-1.5 text-sm";

export const fullName = (u: {
  first_name: string | null;
  last_name: string | null;
  email: string | null;
}): string => [u.first_name, u.last_name].filter(Boolean).join(" ").trim() || u.email || "—";
